import './App.css';

import { HelmetProvider } from 'react-helmet-async';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

import Footer from '@/components/Footer/Footer';
import { Navbar } from '@/components/Navbar/Navbar';
import { Addition } from '@/pages/Addition';
import { Multiplication } from '@/pages/Multiplication';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/multiplication" element={<Multiplication />} />
            <Route path="/addition" element={<Addition />} />
            <Route
              path="/"
              element={<Navigate to="/multiplication" replace />}
            />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
